module.exports = __webpack_public_path__ + "img/bcuApp_qr.73ce257c.svg";